/**
 * 用户来源
 */
export enum SOURCE_ENUM {
  /**
   * CIAM 导入
   */
  CIAM = 'CIAM',
  /**
   * 手工录入
   */
  MANUAL = 'MANUAL'
}

/**
 * 菜单类型
 */
export enum MENU_TYPE_ENUM {
  /**
   * 菜单
   */
  MENU = 'MENU',
  /**
   * 按钮
   */
  BUTTON = 'BUTTON'
}

/**
 * 租户类型
 */
export enum TENANT_TYPE_ENUM {
  /**
   * 内部租户
   */
  INNER = 'INNER',
  /**
   * 外部租户
   */
  OUTER = 'OUTER'
}
